import { render, staticRenderFns } from "./SelectStatus.vue?vue&type=template&id=49554758&scoped=true&"
import script from "./SelectStatus.vue?vue&type=script&lang=ts&"
export * from "./SelectStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SelectStatus.vue?vue&type=style&index=0&id=49554758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49554758",
  null
  
)

export default component.exports